// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "common-inbox" + "." + "5526f474dc1fd2de7490" + ".js";
};